import * as React from "react";
import { CheckCircle2, Info } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const subsidyTiers = [{
  title: "一般戶",
  amount: "10,000",
  description: "符合基本申請資格之一般家庭",
  features: ["基礎設備檢測與評估", "標準補助額度申請", "專人線上諮詢服務"]
}, {
  title: "中低收入戶",
  amount: "15,000",
  description: "經主管機關核定之中低收入戶",
  features: ["優先排程到府檢測", "進階補助額度申請", "專案輔導文件準備", "完工後續追蹤服務"]
}, {
  title: "低收入戶",
  amount: "20,000",
  description: "經主管機關核定之低收入戶",
  features: ["全額優先排程處理", "最高專案補助額度", "專人全程代辦服務", "免收任何評估費用"]
}];
export default function SubsidyAmountExplanation() {
  return <section id="補助金額說明" className="relative w-full bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_50%)] opacity-[0.03] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            專案補助金額說明
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl">
            我們針對不同身份別提供對應的補助方案，減輕您的財務負擔，讓居家環境改善更加輕鬆無礙。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {subsidyTiers.map((tier, index) => <div data-index={index} key={index} className="flex">
              <Card className="relative w-full flex flex-col overflow-hidden bg-background/60 backdrop-blur-xl border-border/50 shadow-lg hover:shadow-xl transition-shadow duration-300">
                {}
                <div className="absolute top-0 left-0 right-0 h-1.5 bg-primary" />

                <CardHeader className="text-center pb-4 pt-8">
                  <CardTitle className="text-xl font-semibold text-foreground mb-2">
                    {tier.title}
                  </CardTitle>
                  <CardDescription className="text-sm text-muted-foreground min-h-[40px]">
                    {tier.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow flex flex-col items-center">
                  <div className="mb-8 text-center">
                    <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-1 block">
                      最高補助
                    </span>
                    <div className="flex items-start justify-center text-primary">
                      <span className="text-2xl font-bold mt-1 mr-1">NT$</span>
                      {}
                      <span className="text-5xl md:text-6xl font-bold font-sans tracking-tighter">
                        {tier.amount}
                      </span>
                    </div>
                  </div>

                  <div className="w-full space-y-3 mt-auto">
                    {tier.features.map((feature, fIndex) => <div data-index={fIndex} key={fIndex} className="flex items-center text-sm text-foreground/80">
                        <CheckCircle2 className="w-4 h-4 text-primary mr-3 shrink-0" />
                        <span>{feature}</span>
                      </div>)}
                  </div>
                </CardContent>
                
                {}
                <div className="px-6 pb-6 pt-2 mt-auto">
                   <div className="flex items-center justify-center text-xs text-muted-foreground/70 bg-muted/30 py-2 rounded-md">
                      <Info className="w-3 h-3 mr-1.5" />
                      實際補助金額依最終審核為準
                   </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}